import React, { useCallback, useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import { Notification } from '../../interfaces/backend/Notification';
import { User } from '../../interfaces/api/Auth';
import { Channels } from '../common/channelsEnum';
import { Environment } from '../../interfaces/backend/Environments';
import {
  BackendCodeSampleTabs,
  MobileCodeSampleTabs
} from '../codeSamples/tabs';
import { UserObject } from '../codeSamples/samples/CodeSample';
import { Template } from '../../interfaces/backend/Template';
import { useParams } from 'react-router-dom';
import { api } from '../../utils/axiosConfig';
import { getAllTags } from './LiquidizedPreview';

interface PlaygroundProps {
  notification: Notification;
  environment: Environment;
  user: User;
}

const Playground: React.FC<PlaygroundProps> = ({
  environment,
  notification,
  user
}) => {
  const [mergeTags, setMergeTags] = useState<Record<string, unknown>>();
  const { notificationId, accountId } =
    useParams<{ notificationId: string; accountId: string }>();

  const getMergeTags = useCallback(async (): Promise<void> => {
    const responses = await Promise.all(
      Object.values(Channels).map((channel) => {
        const url = `/${accountId}/notifications/${notificationId}/templates/${channel}`;
        return api('GET', url);
      })
    );

    const newTemplates = responses.map(
      (res) => (res as Record<'data', Template[]>).data
    );

    const templates = newTemplates.flat();

    setMergeTags(
      getAllTags(
        templates.filter((t) => notification.channels.includes(t.channel))
      ).mergeTagsObject
    );
  }, [accountId, notificationId, notification.channels]);

  useEffect(() => {
    getMergeTags();
  }, [getMergeTags, accountId]);

  const userObject: UserObject = {
    id: user?.attributes.email ?? 'user',
    email: user?.attributes.email,
    number: '+15005550006'
  };

  if (!notification) return <></>;

  return (
    <>
      <Row>
        <Col lg={22}>
          <Card title="✉️ Trigger This Notification (Back-End)">
            <BackendCodeSampleTabs
              environment={environment}
              notification={notification}
              user={userObject}
              mergeTags={mergeTags}
            />
          </Card>

          {notification.channels.includes(Channels.PUSH) && (
            <Card
              title="Mobile Push Integration (iOS, Android, React Native)"
              style={{
                marginTop: '24px'
              }}
            >
              <MobileCodeSampleTabs
                environment={environment}
                notification={notification}
                user={userObject}
              />
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Playground;
